import StaffAddPage from './StaffAddPage';

export default StaffAddPage;
